export default __webpack_public_path__ + "_/images/app/telegram/telegram-en-3-74c3bdcf703db06ed7e1f1fd7f4e8bb4c79ca10b380a3b6c2707118a611a0d3b.jpg";